import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Icons from './IconProvider';

const Hero: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToNext = () => {
    if (scrollRef.current) {
      const servicesSection = document.getElementById('services');
      servicesSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-40 pb-20 overflow-hidden bg-gradient-to-br from-gray-50 to-white"
    >
      <div className="container relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8 md:mb-12 px-4 sm:px-0"
          >
            <span className="inline-block px-4 py-2 rounded-full bg-black text-white text-sm font-medium mb-8">
              Premium Wealth Management
            </span>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.2] md:leading-[1.1] mb-6 md:mb-8">
              Unlock the <span className="font-serif italic font-normal">Potential</span> of Your Investments
            </h1>
            <p className="text-base sm:text-lg text-gray-600 mb-8 md:mb-10 max-w-2xl mx-auto">
              We transform your demat accounts into powerful profit-generating assets with our expert-led, data-driven strategies.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a href="#contact" className="btn-primary">
                Start Investing
              </a>
              <a href="#services" className="btn-outline">
                Explore Services
              </a>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative w-full max-w-[1100px] mx-auto mt-12 md:mt-16 px-4"
          >
            <div className="relative aspect-[16/9] rounded-2xl overflow-hidden">
              <img 
                src="https://images.pexels.com/photos/7567434/pexels-photo-7567434.jpeg?auto=compress&cs=tinysrgb&w=1920" 
                alt="Financial data visualization" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              <div className="absolute inset-0 ring-1 ring-white/20 rounded-2xl"></div>
            </div>
            <div className="absolute -inset-4 -z-10">
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/20 to-accent-500/20 blur-3xl rounded-[inherit] transform scale-[0.80] opacity-50"></div>
            </div>
          </motion.div>
        </div>
      </div>
      
      {/* Abstract shapes */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-primary-50 rounded-full filter blur-[100px] opacity-50"></div>
      <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-accent-50 rounded-full filter blur-[120px] opacity-40"></div>
    </section>
  );
};

export default Hero;